import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'muni-gameday-category-color',
  template: `
      <span
        class="category-color"
        [style.backgroundColor]="color">
      </span>
  `,
  styles: [
    `
      .category-color {
        display: block;
        float: left;
        content: '';
        width: 10px;
        height: 10px;
        margin: 8px auto;
        border-radius: 2px;
      }
    `
  ],
  standalone: false,
})
export class CategoryColorComponent implements ICellRendererAngularComp {
  public color: string;

  public refresh(params: ICellRendererParams): boolean {
    return false;
  }

  public agInit(params: ICellRendererParams): void {
    if (params.data) {
      this.color = params.data.categoryColor;
    }
  }
}
